import React from 'react';
import { Menu, Button, message } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

const TopNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = (e: { key: string }) => {
    if (e.key === 'admin') {
      window.open('/admin/', '_blank'); // 在新标签页打开管理页
    } else {
      navigate(e.key); // 跳转到对应页面
    }
  };
  
  const handleLogout = () => {
    localStorage.removeItem('token');
    message.success('已登出');
    navigate('/login');
  };
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', padding: '0 20px' }}>
      <div style={{ flex: 1 }}>
        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>AI报告审核</span>
        <Menu 
          mode="horizontal"
          selectedKeys={[location.pathname]}
          onClick={handleMenuClick}
          style={{ display: 'inline-block', marginLeft: '20px', minWidth: '600px' }}
        >
          <Menu.Item key="/dashboard">报告审核</Menu.Item>
          <Menu.Item key="/review-history">审核历史</Menu.Item>
          <Menu.Item key="/review-rules">审核规则</Menu.Item>
          <Menu.Item key="/labs">实验室管理</Menu.Item>
          <Menu.Item key="admin">管理页</Menu.Item>
        </Menu>
      </div>
      <Button type="text" onClick={handleLogout} icon={<LogoutOutlined />}>登出</Button>
    </div>
  );
};

export default TopNav;